module.exports = __webpack_public_path__ + "img/logo-5.d02a46f4.png";